import { Chart } from "react-google-charts";
import { useBuscarUsuarios } from "../hooks/useBuscarUsuarios";
import { agruparUsuariosPorMesAno } from "../utils/agruparData";

function Dashboard() {
  // Busca os dados dos usuários cadastrados
  const { usuarios } = useBuscarUsuarios();

  // Define as opções do gráfico
  const options = {
    colors: ["#003644"], // Define a cor das colunas
    hAxis: {
      title: "Mês/Ano",
    },
    vAxis: {
      title: "Usuários Acumulados",
    },
  };

  // Prepara os dados do gráfico
  const groupedData = agruparUsuariosPorMesAno(usuarios);
  let acumulado = 0;

  // Cria array acumulado completo
const dataAcumulada = groupedData.map(([mesAno, usuariosNoMes]) => {
  acumulado += usuariosNoMes;
  return [mesAno, acumulado];
});
  // Calcula a data limite (12 meses atrás)
  const hoje = new Date();
  const dataLimite = new Date(hoje.getFullYear(), hoje.getMonth() - 11, 1); // 12 meses incluindo o mês atual

  // Filtra apenas os últimos 12 meses
const dataFiltrada = dataAcumulada.filter(([mesAno]) => {
  const [mes, ano] = String(mesAno).split("/").map(Number);
  const data = new Date(ano, mes - 1, 1);
  return data >= dataLimite;
});


// Monta o array final para o gráfico
const data = [
  ["Mês/Ano", "Usuários Acumulados"],
  ...dataFiltrada
];

  return (
    <Chart
      chartType="LineChart"
      width="100%"
      height="400px"
      data={data}
      options={options}
      
    />
  );
}

export default Dashboard;
